import React from "react";

function SubmarineQuestTOS() {
  return (
    <div style={{ padding: "2rem", backgroundColor: "#000", color: "#fff" }}>
      <h1>Terms of Service for Submarine Quest</h1>
      <p><strong>Last Updated: 2nd Jul 2026</strong></p>

      <p>
        Welcome, and thank you for playing <strong>Submarine Quest</strong> (“the
        Game”). These Terms of Service (“Terms”) are a legal agreement between you
        and <strong>KHAOLAM INTERACTIVE COMPANY LIMITED</strong> (“we”, “us”, or
        “our”) governing your access to and use of the Game and any related
        services (together, “the Services”). By downloading, installing, or
        playing the Game, you agree to be bound by these Terms. If you do not
        agree, please do not use the Services.
      </p>

      <h2>1. Eligibility</h2>
      <p>
        You must be old enough to form a binding contract in your country of
        residence, or have the consent of a parent or legal guardian, to use the
        Services. If you are below the minimum age required by local regulations
        (e.g., 13 in the U.S.), you may only use the Game with the involvement and
        consent of a parent or guardian.
      </p>

      <h2>2. License to Use the Game</h2>
      <p>
        Subject to your compliance with these Terms, we grant you a limited,
        non-exclusive, non-transferable, revocable license to download and use the
        Game on a device you own or control, solely for your personal,
        non-commercial entertainment. We reserve all rights not expressly granted
        to you.
      </p>

      <h2>3. Acceptable Use</h2>
      <p>You agree that you will not:</p>
      <ul>
        <li>Cheat, exploit bugs, or use unauthorized third-party software, bots, or hacks;</li>
        <li>Reverse engineer, decompile, or attempt to extract the source code of the Game, except as permitted by law;</li>
        <li>Copy, modify, distribute, sell, or lease any part of the Game;</li>
        <li>Interfere with, disrupt, or place undue load on our servers or networks;</li>
        <li>Use the Services for any unlawful, fraudulent, or harmful purpose.</li>
      </ul>

      <h2>4. In-App Purchases &amp; Virtual Items</h2>
      <p>
        The Game may offer in-app purchases, virtual currency, or virtual items
        (“Virtual Items”). All purchases are processed through <strong>Apple’s App
        Store</strong> or the <strong>Google Play Store</strong>, and we do not
        collect or store your payment information. Virtual Items have no monetary
        value, cannot be exchanged for real money, and are licensed to you, not
        sold. Except where required by law, all purchases are final and
        non-refundable. Refund requests are handled by the applicable app store
        under its own policies.
      </p>

      <h2>5. Advertising</h2>
      <p>
        The Game may display advertisements served through third-party ad networks
        (such as AdMob and Unity Ads). We are not responsible for the content of
        third-party advertisements or the products and services they promote.
      </p>

      <h2>6. Intellectual Property</h2>
      <p>
        The Game, including all software, artwork, characters, audio, text, and
        other content, is owned by KHAOLAM INTERACTIVE COMPANY LIMITED or its
        licensors and is protected by intellectual property laws. Nothing in these
        Terms transfers ownership of any intellectual property to you.
      </p>

      <h2>7. User Accounts &amp; Data</h2>
      <p>
        Some features may require an account or use of authentication services such
        as Google Play Games (Android) or Apple Game Center (iOS). You are
        responsible for maintaining the confidentiality of your account and for all
        activity that occurs under it. Our collection and use of personal
        information is described in our Privacy Policy.
      </p>

      <h2>8. Updates &amp; Availability</h2>
      <p>
        We may update, modify, or discontinue the Game or any of its features at
        any time, with or without notice. We do not guarantee that the Services
        will always be available, uninterrupted, or error-free.
      </p>

      <h2>9. Termination</h2>
      <p>
        We may suspend or terminate your access to the Services at any time if you
        violate these Terms or engage in conduct that harms other players, us, or
        third parties. You may stop using the Services at any time by uninstalling
        the Game.
      </p>

      <h2>10. Disclaimer of Warranties</h2>
      <p>
        The Services are provided “as is” and “as available” without warranties of
        any kind, whether express or implied, including but not limited to implied
        warranties of merchantability, fitness for a particular purpose, and
        non-infringement, to the fullest extent permitted by law.
      </p>

      <h2>11. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, KHAOLAM INTERACTIVE COMPANY LIMITED
        shall not be liable for any indirect, incidental, special, consequential,
        or punitive damages, or any loss of data, profits, or goodwill, arising out
        of or in connection with your use of the Services.
      </p>

      <h2>12. Changes to These Terms</h2>
      <p>
        We may revise these Terms from time to time. When we do, we will update the
        “Last Updated” date above. Your continued use of the Services after changes
        take effect constitutes acceptance of the revised Terms.
      </p>

      <h2>13. Governing Law &amp; Disputes</h2>
      <p>
        The Game is distributed worldwide through the Apple App Store and Google
        Play Store. These Terms are governed by the laws of the Kingdom of
        Thailand, without regard to its conflict of law principles, except where
        the mandatory consumer-protection laws of your country of residence provide
        you greater protection. You and KHAOLAM INTERACTIVE COMPANY LIMITED agree
        that any dispute arising out of or relating to these Terms or the Services
        will be resolved in the courts located in Bangkok, Thailand, and you
        consent to their jurisdiction, unless applicable law in your country of
        residence requires otherwise.
      </p>

      <h2>14. General</h2>
      <p>
        These Terms, together with our Privacy Policy, make up the entire agreement
        between you and us regarding the Services and supersede any prior
        agreements. If any provision of these Terms is found to be unenforceable,
        the remaining provisions will remain in full force and effect. Our failure
        to enforce any right or provision is not a waiver of that right. You may not
        assign or transfer these Terms without our prior written consent, and any
        attempt to do so is void; we may assign these Terms without restriction.
      </p>

      <h2>15. Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us at{" "}
        <strong>tech@khaolam.com</strong>.
      </p>
    </div>
  );
}

export default SubmarineQuestTOS;
